import { Outlet, Route } from 'react-router'
import { ROUTES } from '../constants'
import { ROUTES as GENERIC_ROUTES } from '../constants/routes/routes-generic'
import { AccountTypeEnum } from '../constants/api/account-type-enum'
import { routerGeneric } from './generic/router-generic'
import { HomePage } from './home'
import { routerHYCS } from './hycs/router-hycs'
import { AccountNameWrapperPage } from './investments/account-name'
import { AccountOwnershipPage } from './investments/account-ownership'
import { CashEquivalentPage } from './investments/cash-equivalent'
import { DisclosuresCompanionPage } from './investments/disclosures-companion'
import { EquityPage } from './investments/equity'
import { FilingStatusPage } from './investments/filing-status'
import { FixedIncomePage } from './investments/fixed-income'
import { GetStartedPage } from './investments/get-started'
import { IntroPage } from './investments/intro'
import { IntroCompanionPage } from './investments/intro-companion'
import { InvestmentGoalsPage } from './investments/investment-goals'
import { LoadingPage } from './investments/loading'
import { PersonalInfoPage } from './investments/personal-info'
import { PersonalizationCompletePage } from './investments/personalization-complete'
import { PortfolioSettingsPage } from './investments/portfolio-settings'
import { PortfolioSettingsOverviewPage } from './investments/portfolio-settings-overview'
import { RiskReturnPage } from './investments/risk-return'
import { SuitabilityPage } from './investments/suitability'
import { ConfirmInformationV2Page } from './investments/v2/confirm-information-v2'
import { DisclosureWrapperPage } from './investments/v2/disclosures-v2'
import { WelcomeCompanionPage } from './investments/welcome-companion'
import { WelcomeWrapper } from './investments/welcome-wrapper'
import { routerMulti } from './multi/router-multi'
import { routerJoint } from './joint/router-joint'
import { SelectAccountPage } from './joint/select-account'
import { AccountSelectionV2Page } from './investments/v2/account-selection-v2'
//INTEGRATION:EnrolmentImports

export const Enrollment = [
  <Route
    key="location-manager"
    path=""
    element={
      <>
        {/* Add custom LocationManager component here to add any redirect logic */}
        <Outlet />
      </>
    }
  >
    {/* Do not move this route, it's used as an entry point to start enrollments */}
    <Route path={ROUTES.HOME.path} element={<HomePage />} />

    <Route path={GENERIC_ROUTES.SELECT_ACCOUNT.path} element={<SelectAccountPage />} />

    {/* JOINT */}
    {routerJoint()}
    {/* MULTI */}
    {routerMulti()}
    {/* HYCS */}
    {routerHYCS()}
    {/* GENERIC ROUTES - TERMINAL STATE PAGES */}
    {routerGeneric()}

    {/* INTEGRATION:EnrollmentRoute */}
    <Route path={ROUTES.CONFIRM_INFORMATION_V2.path} element={<ConfirmInformationV2Page />} />
    <Route path={ROUTES.INVESTMENTS_WELCOME_COMPANION.path} element={<WelcomeCompanionPage />} />
    <Route path={ROUTES.INVESTMENTS_INTRO_COMPANION.path} element={<IntroCompanionPage />} />
    <Route path={ROUTES.INVESTMENTS_PORTFOLIO_SETTINGS.path} element={<PortfolioSettingsPage />} />
    <Route path={ROUTES.INVESTMENTS_PORTFOLIO_SETTINGS_OVERVIEW.path} element={<PortfolioSettingsOverviewPage />} />
    <Route
      path={ROUTES.INVESTMENTS_DISCLOSURES_BROKERAGE.path}
      element={<DisclosureWrapperPage accountType={AccountTypeEnum.BROKERAGE} />}
    />
    <Route
      path={ROUTES.INVESTMENTS_DISCLOSURES_IRA.path}
      element={<DisclosureWrapperPage accountType={AccountTypeEnum.TRADITIONAL} />}
    />
    <Route
      path={ROUTES.INVESTMENTS_DISCLOSURES_ROTH.path}
      element={<DisclosureWrapperPage accountType={AccountTypeEnum.TRADITIONAL} />}
    />
    <Route path={ROUTES.INVESTMENTS_DISCLOSURES_ROTH_INHERITED.path} element={<DisclosureWrapperPage />} />
    <Route path={ROUTES.INVESTMENTS_DISCLOSURES_TRADITIONAL_INHERITED.path} element={<DisclosureWrapperPage />} />

    <Route path={ROUTES.INVESTMENTS_LOADING.path} element={<LoadingPage />} />
    <Route path={ROUTES.INVESTMENTS_PERSONALIZATION_COMPLETE.path} element={<PersonalizationCompletePage />} />
    <Route path={ROUTES.INVESTMENTS_CASH_EQUIVALENT.path} element={<CashEquivalentPage />} />
    <Route path={ROUTES.INVESTMENTS_FIXED_INCOME.path} element={<FixedIncomePage />} />
    <Route path={ROUTES.INVESTMENTS_EQUITY.path} element={<EquityPage />} />
    <Route path={ROUTES.INVESTMENTS_RISK_RETURN.path} element={<RiskReturnPage />} />
    {/* TODO: Remove Welcome Wrapper once Apex Migration is complete */}
    <Route path={ROUTES.INVESTMENTS_WELCOME.path} element={<WelcomeWrapper />} />
    <Route path={ROUTES.INVESTMENTS_INVESTMENT_GOALS.path} element={<InvestmentGoalsPage />} />
    <Route path={ROUTES.INVESTMENTS_FILING_STATUS.path} element={<FilingStatusPage />} />
    <Route path={ROUTES.INVESTMENTS_ACCOUNT_NAME.path} element={<AccountNameWrapperPage />} />
    <Route path={ROUTES.INVESTMENTS_SUITABILITY.path} element={<SuitabilityPage />} />
    <Route path={ROUTES.INVESTMENTS_PERSONAL_INFO.path} element={<PersonalInfoPage />} />
    <Route path={ROUTES.INVESTMENTS_GET_STARTED.path} element={<GetStartedPage />} />
    <Route path={ROUTES.INVESTMENTS_ACCOUNT_SELECTION.path} element={<AccountSelectionV2Page />} />
    <Route path={ROUTES.INVESTMENTS_ACCOUNT_OWNERSHIP.path} element={<AccountOwnershipPage />} />
    <Route path={ROUTES.INVESTMENTS_INTRO.path} element={<IntroPage />} />
    {/* Disclosures Companion Start */}
    <Route
      path={ROUTES.INVESTMENTS_DISCLOSURES_COMPANION_BROKERAGE.path}
      element={<DisclosuresCompanionPage accountType={AccountTypeEnum.BROKERAGE} />}
    />
    <Route
      path={ROUTES.INVESTMENTS_DISCLOSURES_COMPANION_IRA.path}
      element={<DisclosuresCompanionPage accountType={AccountTypeEnum.TRADITIONAL} />}
    />
    <Route
      path={ROUTES.INVESTMENTS_DISCLOSURES_COMPANION_ROTH.path}
      element={<DisclosuresCompanionPage accountType={AccountTypeEnum.TRADITIONAL} />}
    />
    {/* Disclosures Companion End */}
  </Route>,
]
